import comp from "./DisplaySettingsButton";
export default comp;
